// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pin-wrapper-modal-box {
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* backdrop */
.pin-wrapper-modal-box .MuiBackdrop-root {
  background: rgba(0, 0, 0, 0.4);
}

/* main modal container (MUI Box inside Modal) */
.pin-wrapper-modal-box > .MuiBox-root {
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 28px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 0;
  outline: none;
  position: relative;
}

/* input section wrapper */
.change-pin-wrapper-box {
  display: flex;
  flex-direction: column;

  padding: 16px 24px;
}

/* label text */
.old-pin-text {
  font-size: 0.875rem;
  font-weight: 900;
  color: #0f172a;
}
.old-pin-text:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

/* input field */
.change-pin-otp-input {
  width: 100%;
  height: 48px;
  padding: 0 12px;
  font-size: 16px;
  border-radius: 16px;
  border: 1px solid #d1d5db;
  background: transparent;
  transition: all 0.2s ease;
  outline: none;
}

.change-pin-otp-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 1px #6366f1;
}

/* resend otp section */
.resend-otp-wrapper-box {
  padding: 0 24px 12px;
}

.resend-otp-wrapper-box p {
  margin: 0;
  font-size: 14px;
  transition: 0.2s ease;
}

/* footer buttons */
.save-wrapper-box-forgot {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px 24px;
}

.save-wrapper-box-forgot button {
  border-radius: 16px;
  min-height: 36px;
  font-size: 14px;
}
.modal-header {
  display: flex;
  flex-direction: column;
  /* space-y-1.5 */

  text-align: left; /* text-left */

  border-bottom: 1px solid rgba(203, 213, 225, 0.6); /* border-border/60 (slate-300 @ 60%) */
  /* px-6 */
  padding-right: 1.5rem; /* px-6 */
  padding-top: 1.25rem; /* py-5 */
  padding-bottom: 1.25rem;
  padding-left: 1.4rem; /* py-5 */
}
input[readonly] {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #64748b;
  cursor: not-allowed;
  pointer-events: none;
}

/* ── Dark mode ── */
.dark .pin-wrapper-modal-box > .MuiBox-root {
  background: #1e293b;
  border-color: #334155;
}

.dark .old-pin-text {
  color: #f1f5f9;
}

.dark .change-pin-otp-input {
  background: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .modal-header {
  border-bottom-color: rgba(51, 65, 85, 0.6);
}

.dark .save-wrapper-box-forgot {
  border-top-color: rgba(51, 65, 85, 0.6);
}

.dark input[readonly] {
  background-color: #334155;
  border-color: #475569;
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/ProfileEditPage/ProfileEditPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;;EAEtB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;EAEhB,gBAAgB,EAAE,cAAc;;EAEhC,iDAAiD,EAAE,uCAAuC;EAC1F,SAAS;EACT,qBAAqB,EAAE,SAAS;EAChC,oBAAoB,EAAE,SAAS;EAC/B,uBAAuB;EACvB,oBAAoB,EAAE,SAAS;AACjC;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".pin-wrapper-modal-box {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* backdrop */\n.pin-wrapper-modal-box .MuiBackdrop-root {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n/* main modal container (MUI Box inside Modal) */\n.pin-wrapper-modal-box > .MuiBox-root {\n  width: 100%;\n  max-width: 460px;\n  background: #ffffff;\n  border-radius: 28px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  padding: 0;\n  outline: none;\n  position: relative;\n}\n\n/* input section wrapper */\n.change-pin-wrapper-box {\n  display: flex;\n  flex-direction: column;\n\n  padding: 16px 24px;\n}\n\n/* label text */\n.old-pin-text {\n  font-size: 0.875rem;\n  font-weight: 900;\n  color: #0f172a;\n}\n.old-pin-text:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* input field */\n.change-pin-otp-input {\n  width: 100%;\n  height: 48px;\n  padding: 0 12px;\n  font-size: 16px;\n  border-radius: 16px;\n  border: 1px solid #d1d5db;\n  background: transparent;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.change-pin-otp-input:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 1px #6366f1;\n}\n\n/* resend otp section */\n.resend-otp-wrapper-box {\n  padding: 0 24px 12px;\n}\n\n.resend-otp-wrapper-box p {\n  margin: 0;\n  font-size: 14px;\n  transition: 0.2s ease;\n}\n\n/* footer buttons */\n.save-wrapper-box-forgot {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 16px 24px;\n}\n\n.save-wrapper-box-forgot button {\n  border-radius: 16px;\n  min-height: 36px;\n  font-size: 14px;\n}\n.modal-header {\n  display: flex;\n  flex-direction: column;\n  /* space-y-1.5 */\n\n  text-align: left; /* text-left */\n\n  border-bottom: 1px solid rgba(203, 213, 225, 0.6); /* border-border/60 (slate-300 @ 60%) */\n  /* px-6 */\n  padding-right: 1.5rem; /* px-6 */\n  padding-top: 1.25rem; /* py-5 */\n  padding-bottom: 1.25rem;\n  padding-left: 1.4rem; /* py-5 */\n}\ninput[readonly] {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  color: #64748b;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* ── Dark mode ── */\n.dark .pin-wrapper-modal-box > .MuiBox-root {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .old-pin-text {\n  color: #f1f5f9;\n}\n\n.dark .change-pin-otp-input {\n  background: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .modal-header {\n  border-bottom-color: rgba(51, 65, 85, 0.6);\n}\n\n.dark .save-wrapper-box-forgot {\n  border-top-color: rgba(51, 65, 85, 0.6);\n}\n\n.dark input[readonly] {\n  background-color: #334155;\n  border-color: #475569;\n  color: #94a3b8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
